import DashboardGoSupport from './DashboardGoSupport';
import { DashboardControlsProvider } from 'contexts/Dashboard/useDashboardControls';
import ViewActionsBar from '../../components/Dashboard/ViewActionsBar';
import GoSupportFilterBar from './GoSupportFilterBar';
import { DefaultGoSupportWidgets, GoSupportWidgetsEnum } from './utils';

const GoSupportDashboardPage = () => {
  return (
    <DashboardControlsProvider<GoSupportWidgetsEnum>
      storageKey="GoSupport"
      serverLayoutKey="GoSupport"
      defaultWidgets={DefaultGoSupportWidgets}
    >
      <GoSupportFilterBar />
      <ViewActionsBar />
      <DashboardGoSupport />
    </DashboardControlsProvider>
  );
};

export default GoSupportDashboardPage;
